import { Component } from 'react';
import $ from 'jquery';
import _ from 'lodash';
import PropTypes from 'proptypes';
import DropDown from '../../semantic_select_modules/semantic/components/dropdown';
import Transition from '../../semantic_select_modules/semantic/components/transition';
import SelectCustom from '../../semantic_select_modules/terugkerendeElementen/form/select';
import SemanticSelectCustom from '../../semantic_select_modules/terugkerendeElementen/form/semanticSelect';

class SelectComponent extends Component {
  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.initSemantic = this.initSemantic.bind(this);
  }

  componentDidMount() {
    this.initSemantic();
  }

  onChangeHandler(e) {
    this.props.onChangeHandler(e);
  }

  initSemantic() {
    DropDown($, window, document, undefined);
    Transition($, window, document, undefined);
    SelectCustom.init();
    SemanticSelectCustom.init();
  }

  render() {
    const { labels, selected, name, label, errorFieldKeys } = this.props;
    let errorBorder;

    setTimeout(() => {
      this.initSemantic();
    }, 200);

    if (!_.isEmpty(errorFieldKeys) && errorFieldKeys.some(key => key.indexOf(name) !== -1)) {
      errorBorder = 'error';
    }

    const optionFields = labels
      .map(labelItem => (
        <option key={labelItem.id} value={labelItem.value}>{labelItem.name}</option>
    ));

    return (
      <div className={`formField selectField ${errorBorder} ${this.props.classNames}`}>
        <label className={'formField_label inputField_label required'} htmlFor={name}>{label}</label>
        <select
          className="selectField_select"
          value={selected}
          name={name}
          onChange={this.onChangeHandler}
        >
          <option defaultValue="true">Maak aub een keuze</option>
          {optionFields}
        </select>
        { this.props.children }
      </div>
    );
  }
}

SelectComponent.propTypes = {
  errorFieldKeys: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
  classNames: PropTypes.string,
  labels: PropTypes.arrayOf(PropTypes.shape({})),
  name: PropTypes.string,
  label: PropTypes.string,
  onChangeHandler: PropTypes.func,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

SelectComponent.defaultProps = {
  errorFieldKeys: [],
  children: '',
  classNames: '',
  name: '',
  label: '',
  labels: [''],
  onChangeHandler() {
  },
  selected: '',
};

export default SelectComponent;
